"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantUpdateSuggestion = instanceOfVariantUpdateSuggestion;
exports.VariantUpdateSuggestionFromJSON = VariantUpdateSuggestionFromJSON;
exports.VariantUpdateSuggestionFromJSONTyped = VariantUpdateSuggestionFromJSONTyped;
exports.VariantUpdateSuggestionToJSON = VariantUpdateSuggestionToJSON;
exports.VariantUpdateSuggestionToJSONTyped = VariantUpdateSuggestionToJSONTyped;
const user_1 = require("./user");
const kindEnum_1 = require("./kindEnum");
const suggestionStatusEnum_1 = require("./suggestionStatusEnum");
const variantInVariantUpdateSuggestion_1 = require("./variantInVariantUpdateSuggestion");
/**
 * Check if a given object implements the VariantUpdateSuggestion interface.
 */
function instanceOfVariantUpdateSuggestion(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    if (!('variants' in value) || value['variants'] === undefined)
        return false;
    if (!('issue' in value) || value['issue'] === undefined)
        return false;
    if (!('solution' in value) || value['solution'] === undefined)
        return false;
    if (!('comment' in value) || value['comment'] === undefined)
        return false;
    if (!('suggestedBy' in value) || value['suggestedBy'] === undefined)
        return false;
    if (!('created' in value) || value['created'] === undefined)
        return false;
    return true;
}
function VariantUpdateSuggestionFromJSON(json) {
    return VariantUpdateSuggestionFromJSONTyped(json, false);
}
function VariantUpdateSuggestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': (0, suggestionStatusEnum_1.SuggestionStatusEnumFromJSON)(json['status']),
        'kind': (0, kindEnum_1.KindEnumFromJSON)(json['kind']),
        'variants': (json['variants'].map(variantInVariantUpdateSuggestion_1.VariantInVariantUpdateSuggestionFromJSON)),
        'issue': json['issue'],
        'solution': json['solution'],
        'comment': json['comment'],
        'suggestedBy': (0, user_1.UserFromJSON)(json['suggestedBy']),
        'created': (new Date(json['created'])),
    };
}
function VariantUpdateSuggestionToJSON(json) {
    return VariantUpdateSuggestionToJSONTyped(json, false);
}
function VariantUpdateSuggestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'kind': (0, kindEnum_1.KindEnumToJSON)(value['kind']),
        'variants': (value['variants'].map(variantInVariantUpdateSuggestion_1.VariantInVariantUpdateSuggestionToJSON)),
        'issue': value['issue'],
        'solution': value['solution'],
        'comment': value['comment'],
    };
}
//# sourceMappingURL=variantUpdateSuggestion.js.map